export const initialState = {
    artPerPage: "",
    order: "ASC"
}